<template>
  <div>
        <b-table show-empty empty-text="This user has no locations set at this time." striped responsive stacked="md" :items="items" :fields="fields">
        <template v-slot:cell(hospital.0.hospital)="row">
        <div v-for="hospital in row.item.hospital" :key="hospital.hospital">
          {{ hospital.hospital }}<br>
        </div>
        </template>
        <template v-slot:cell(actions)="row" class="text-nowrap">
                    <b-button @click="deleteLocation(row.item.id)" class="btn btn-danger">
                        <span class="icon icon-trash"></span>
                    </b-button>
            </template>
        </b-table>
        <b-form-group label="Add Location">
        <b-form-select label="Locations" v-model="selected">
          <option v-for="location in locations" :key="location.id" :value="location.id">
            {{ location.hospital }}
            </option>
        </b-form-select>
        <b-button @click="addLocation(selected)" class="btn btn-success">
            <span class="icon icon-plus"></span>
        </b-button>
        </b-form-group>
  </div>
</template>

<script>
const items = [];

export default {
    props: ['hospitals', 'user', 'local'],
  data() {
    return {
      selected: null,
      items: this.hospitals,
      locations: this.local,
      fields: [
        { key: "hospital", label: "Location" },
        { key: "actions", label: "Remove" },
      ],
    };
  },
  methods: {
    deleteLocation(id) {
       axios.post('/delete/user/location', {
            hospital_id: id,
            user_id: this.user.id
        })
            .then(response => this.items = response.data)
            .catch(function (error) {
                // handle error
                console.log(error);
            });
    },
    addLocation(selected) {
       axios.post('/add/user/location', {
            hospital_id: selected,
            user_id: this.user.id
        })
            .then(response => this.items = response.data)
            .catch(function (error) {
                // handle error
                console.log(error);
            });
    },
  },
};
</script>

<!-- table-basic-1.vue -->